import { render, staticRenderFns } from "./UsersCrud.vue?vue&type=template&id=25155805&scoped=true"
import script from "./UsersCrud.vue?vue&type=script&lang=js"
export * from "./UsersCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25155805",
  null
  
)

export default component.exports